<div class="container-fluid">
  <div class="col-12 main_container">
    <div class="loginContainer">
      <!-- Step 1: Enter Email -->
      @if (!_confirmationStep && !_emailSentStep) {
        <div class="form_center">
          <div class="imagoLogin">
            <img src="/assets/menu/enterprise/logo-enterprise.svg" alt="BarCloud NG" />
          </div>
          <h2 class="loginProjectTitle">Forgot Password</h2>
          <p class="loginSubtitle">
            Enter your email address and we'll send you a link to reset your password.
          </p>
          <div class="form-group">
            <label class="loginInputLabel" for="forgotEmail">Email Address</label>
            <input
              type="email"
              id="forgotEmail"
              [formControl]="_email"
              class="form-control"
              placeholder="Enter Your Email Address"
              [ngClass]="{ 'is-invalid': submitted && _email.invalid }"
              (keyup.enter)="onNext()"
            />
            @if (submitted && _email.invalid) {
              <div class="field-validation-error">
                @if (_email.hasError('required')) {
                  <span>Email address is required.</span>
                }
                @if (!_email.hasError('required') && _email.hasError('email')) {
                  <span>Please enter a valid email address.</span>
                }
              </div>
            }
          </div>
          <div class="form-group loginButtonRow">
            <button type="button" (click)="onNext()" class="btn btn-primary loginBtn">
              Send Reset Link
            </button>
          </div>
          <div class="returnLoginRow">
            <a (click)="onReturn()" class="returnLoginLink">
              &larr; Back to Login
            </a>
          </div>
        </div>
      }

      <!-- Step 2: Confirmation -->
      @if (_confirmationStep) {
        <div class="form_center">
          <div class="imagoLogin">
            <img src="/assets/menu/enterprise/logo-enterprise.svg" alt="BarCloud NG" />
          </div>
          <h2 class="loginProjectTitle">Confirm Password Reset</h2>
          <div class="confirmationCard">
            <p class="confirmationText">A password reset link will be sent to:</p>
            <p class="confirmationEmail">{{ _email.value }}</p>
          </div>
          <div class="buttonGroup">
            <button
              type="button"
              (click)="onSubmit()"
              class="btn btn-primary loginBtn"
              [disabled]="loading"
            >
              @if (loading) {
                <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
              }
              {{ loading ? 'Sending...' : 'Confirm & Send' }}
            </button>
            <button
              type="button"
              (click)="onBackToEdit()"
              class="btn btn-outline-secondary backBtn"
              [disabled]="loading"
            >
              Back
            </button>
          </div>
          @if (error) {
            <div class="identity-invalid-feedback">
              <div>{{ error }}</div>
            </div>
          }
        </div>
      }

      <!-- Step 3: Success -->
      @if (_emailSentStep) {
        <div class="form_center">
          <div class="imagoLogin">
            <img src="/assets/menu/enterprise/logo-enterprise.svg" alt="BarCloud NG" />
          </div>
          <div class="successIconWrapper">
            <svg
              class="successCheckIcon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#6ebf88"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </div>
          <h2 class="loginProjectTitle">Email Sent</h2>
          <p class="loginSubtitle successSubtitle">
            We've sent a password reset link to <strong>{{ _email.value }}</strong>. Please check your inbox and follow the instructions to reset your password.
          </p>
          <div class="form-group loginButtonRow">
            <button type="button" (click)="onReturn()" class="btn btn-primary loginBtn">
              Return to Login
            </button>
          </div>
        </div>
      }
    </div>
  </div>

  <div id="footer" class="asap-auth">
    <div id="sub_footer" class="aa-footer-wrap">
      <div id="footr" class="aa-footer-bar">
        <p id="copyRight" class="aa-copy">Copyright © {{currentYear}}, ASAP Systems</p>

        <nav class="aa-footer-nav">
          <a [href]="footerUrls.contactUsUrl" target="_blank" rel="noopener noreferrer">Contact Us</a>
          <a [href]="footerUrls.returnPolicyUrl" target="_blank" rel="noopener noreferrer">Return Policy</a>
          <a [href]="footerUrls.privacyPolicyUrl" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
          <a [href]="footerUrls.termsOfServiceUrl" target="_blank" rel="noopener noreferrer">Terms of Service</a>
        </nav>
      </div>
    </div>
  </div>
</div>
